import { useMutation, useQueryClient } from '@tanstack/react-query';

import { RegionChannelSettingPayload, updateRegionChannelSetting } from '~/services/PromoService';

import { regionChannelSettingQueryKeys } from './regionChannelSettingQueryKeys';

type Vars = {
  id: string;
  payload: RegionChannelSettingPayload;
};

export function useUpdateRegionChannelSetting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: Vars) => updateRegionChannelSetting(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: regionChannelSettingQueryKeys.lists() });
    },
  });
}
